import { c as _c } from "react/compiler-runtime";
import type React from "react";
import { ChevronDown, ChevronUp } from "lucide-react";
import { cn } from "@/lib/utils";
interface AnimatedCircleProps {
  className?: string;
  inverted?: boolean;
}
export const AnimatedCircle: React.FC<AnimatedCircleProps> = t0 => {
  const $ = _c(7);
  const {
    className: t1,
    inverted: t2
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const inverted = t2 === undefined ? false : t2;
  let t3;
  if ($[0] !== className) {
    t3 = cn("animate-slow-bounce cursor-pointer bg-white rounded-full w-8 h-8 shadow-md flex justify-center items-center border border-gray-200 [&_svg]:size-7 [&_svg]:shrink-0", className);
    $[0] = className;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== inverted) {
    t4 = inverted ? <ChevronUp className="text-gray-500" style={{
      strokeWidth: "1.5px"
    }} /> : <ChevronDown className="text-gray-500" style={{
      strokeWidth: "1.5px"
    }} />;
    $[2] = inverted;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t3 || $[5] !== t4) {
    t5 = <div className={t3} data-sentry-component="AnimatedCircle" data-sentry-source-file="AnimatedCircle.tsx">{t4}</div>;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
};